import { Box } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { Fragment } from 'react'
import { Helmet } from 'react-helmet-async'
import { Route, Switch, useRouteMatch } from 'react-router'
import { Redirect } from 'react-router-dom'
import { SideMenu } from '../../components/Labs/SideMenu'
import { BaseLayout } from '../../layouts'
import { MainContentHeadingBox } from '../../layouts/Base/MainContent'
import { ExportFolderCSV } from "../../components/Labs/ExportCSV"
import { BulkUpdateCSV } from "../../components/Labs/BulkUpdateCSV"


const ExportPage = (): ReactElement => (
  <Fragment>
    <Helmet>
      <title>
        Export folder as CSV
      </title>
      <meta
        name="description"
        content='Export folder as CSV'
      />
    </Helmet>
    <ExportFolderCSV />
  </Fragment>
)

const BulkUpdatePage = (): ReactElement => (
  <Fragment>
    <Helmet>
      <title>Bulk update CSV</title>
      <meta name="description"
        content='Bulk update CSV'
      />
    </Helmet>
    <BulkUpdateCSV />
  </Fragment>
)

export const LabsRouter = (): ReactElement => {
  const { path } = useRouteMatch()

  return (
    <BaseLayout menu={<SideMenu />}>
      <MainContentHeadingBox />
      <Box>
        <Switch>
          <Route path={`${path}`} exact>
            <Redirect to={`${path}/export-folder-csv`} />
          </Route>
          <Route exact path={`${path}/export-folder-csv`}>
            <ExportPage />
          </Route>
          <Route exact path={`${path}/bulk-update-csv`}>
            <BulkUpdatePage />
          </Route>
        </Switch>
      </Box>

    </BaseLayout>
  )
}
